// extracted by mini-css-extract-plugin
module.exports = {"Landing":"Landing_Landing__3WE0r"};